/*
 * "Freeze time" signal shared by the gallery (holding a photo freezes time)
 * and the clock in the top bar (which stops and shows its seconds).
 */
const EVENT = "timefreeze";

export function setTimeFrozen(frozen) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: frozen }));
}

// Calls listener(frozen) on every change; returns a function to stop listening
export function onTimeFreeze(listener) {
  const handle = (event) => listener(event.detail);
  window.addEventListener(EVENT, handle);
  return () => window.removeEventListener(EVENT, handle);
}
